
import {
    MEDALLAS_LOADING,
    MEDALLAS_LOADED,
    MEDALLAS_ERROR,

    MEDALLAS_INDI_LOADING,
    MEDALLAS_INDI_LOADED,
    MEDALLAS_INDI_ERROR,

    MEDALLAS_CONTEXTO_DEX_LOADING,
    MEDALLAS_CONTEXTO_DEX_LOADED,
    MEDALLAS_CONTEXTO_DEX_ERROR,

    MEDALLAS_DEX_LOADING,
    MEDALLAS_DEX_LOADED,
    MEDALLAS_DEX_ERROR,

    CREAR_MEDALLA_DEX_LOADING,
    CREAR_MEDALLA_DEX_LOADED,
    CREAR_MEDALLA_DEX_ERROR,
    RESET_CREAR_MEDALLA_DEX,

    MEDALLAS_USER_DEX_LOADING,
    MEDALLAS_USER_DEX_LOADED,
    MEDALLAS_USER_DEX_ERROR
  } from '../../types/medallas';

const INITIAL_STATE = {
    medalla: [],
    medallaLoading: false,
    medallaLoaded: false,
    medallaError: '',

    medallaind: [],
    medallaindLoading: false,
    medallaindLoaded: false,
    medallaindError: '',  

    medallasuser: [],
    medallasuserLoading: false,
    medallasuserLoaded: false,
    medallasuserError: '',  

    medallasdex: [],
    medallasdexLoading: false,
    medallasdexLoaded: false,
    medallasdexError: '',

    medalladex: [],
    medalladexLoading: false,
    medalladexLoaded: false,
    medalladexError: '',

    agregarmedalladex: [],
    agregarmedalladexLoading: false,
    agregarmedalladexLoaded: false,
    agregarmedalladexError: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case MEDALLAS_USER_DEX_LOADING:
            return {
                ... state,
                medallasuserLoading: true,
                medallasuserLoaded: false,
                medallasuser: [],
                medallasuserError: '',
            }
        case MEDALLAS_USER_DEX_LOADED:
            return {
                ...state,
                medallasuserLoading: false,
                medallasuserLoaded: true,
                medallasuser: action.payload,
                medallasuserError: '',
            };
        case MEDALLAS_USER_DEX_ERROR:
            return {
                ...state,
                medallasuserLoading: false,
                medallasuserLoaded: false,
                medallasuser:[],
                medallasuserError: action.payload,
            }

        case RESET_CREAR_MEDALLA_DEX:
            return {
                ...state,
                agregarmedalladexLoading: false,
                agregarmedalladexLoaded: false,
                agregarmedalladex: [],
                agregarmedalladexError: "",
            };

        case CREAR_MEDALLA_DEX_LOADING:
            return {
                ... state,
                agregarmedalladexLoading: true,
                agregarmedalladexLoaded: false,
                agregarmedalladex: [],
                agregarmedalladexError: '',
            }
        case CREAR_MEDALLA_DEX_LOADED:
            return {
                ...state,
                agregarmedalladexLoading: false,
                agregarmedalladexLoaded: true,
                agregarmedalladex: action.payload,
                agregarmedalladexError: '',

                medalladex: {
                ...state.medalladex,
                    results: [
                        action.payload,
                        ...(state.medalladex?.results || [])
                    ]
                }
            };
        case CREAR_MEDALLA_DEX_ERROR:
            return {
                ...state,
                agregarmedalladexLoading: false,
                agregarmedalladexLoaded: false,
                agregarmedalladex:[],
                agregarmedalladexError: action.payload,
            }

        case MEDALLAS_DEX_LOADING:
            return {
                ... state,
                medalladexLoading: true,
                medalladexLoaded: false,
                medalladex: [],
                medalladexError: '',
            }
        case MEDALLAS_DEX_LOADED:
            return {
                ...state,
                medalladexLoading: false,
                medalladexLoaded: true,
                medalladex: action.payload,
                medalladexError: '',
            };
        case MEDALLAS_DEX_ERROR:
            return {
                ...state,
                medalladexLoading: false,
                medalladexLoaded: false,
                medalladex:[],
                medalladexError: action.payload,
            }

        case MEDALLAS_CONTEXTO_DEX_LOADING:
            return {
                ... state,
                medallasdexLoading: true,
                medallasdexLoaded: false,
                medallasdex: [],
                medallasdexError: '',
            }
        case MEDALLAS_CONTEXTO_DEX_LOADED:
            return {
                ...state,
                medallasdexLoading: false,
                medallasdexLoaded: true,
                medallasdex: action.payload,
                medallasdexError: '',
            };
        case MEDALLAS_CONTEXTO_DEX_ERROR:
            return {
                ...state,
                medallasdexLoading: false,
                medallasdexLoaded: false,
                medallasdex:[],
                medallasdexError: action.payload,
            }

        case MEDALLAS_INDI_LOADING:
            return {
                ... state,
                medallaindLoading: true,
                medallaindLoaded: false,
                medallaind: [],
                medallaindError: '',
            }
        case MEDALLAS_INDI_LOADED:
            return {
                ...state,
                medallaindLoading: false,
                medallaindLoaded: true,
                medallaind: action.payload,
                medallaindError: '',
            };
        case MEDALLAS_INDI_ERROR:
            return {
                ...state,
                medallaindLoading: false,
                medallaindLoaded: false,
                medallaind:[],
                medallaindError: action.payload,
            }

        case MEDALLAS_LOADING:
            return {
                ... state,
                medallaLoading: true,
                medallaLoaded: false,
                medalla: [],
                medallaError: '',
            }
        case MEDALLAS_LOADED:
            return {
                ...state,
                medallaLoading: false,
                medallaLoaded: true,
                medalla: action.payload,
                medallaError: '',
            };
        case MEDALLAS_ERROR:
            return {
                ...state,
                medallaLoading: false,
                medallaLoaded: false,
                medalla:[],
                medallaError: action.payload,
            }
        default: return state;
    }
}